import Chip, { ChipProps } from '@material-ui/core/Chip';
import { emphasize, withStyles } from '@material-ui/core/styles';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

export type StyledBreadcrumbProps = ChipProps<RouterLink, {}>;

const StyledBreadcrumb = React.forwardRef<HTMLAnchorElement, StyledBreadcrumbProps>((props, ref) => (
  <Chip ref={ref} component={RouterLink} {...props} />
));

StyledBreadcrumb.displayName = 'StyledBreadcrumb';

export default withStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.grey[100],
    height: theme.spacing(3),
    color: theme.palette.grey[800],
    fontWeight: theme.typography.fontWeightRegular,
    '&:hover, &:focus': {
      // backgroundColor: theme.palette.grey[300],
      backgroundColor: theme.palette.primary.light,
      color: theme.palette.primary.contrastText,

      '& > svg': {
        color: theme.palette.primary.contrastText,
      },
    },
    '&:active': {
      boxShadow: theme.shadows[1],
      backgroundColor: emphasize(theme.palette.grey[300], 0.12),
    },
  },
}))(StyledBreadcrumb);
